import React from 'react';
import PropTypes from 'prop-types';
import { FaFilePdf, FaFileAlt, FaFileWord, FaFilePowerpoint, FaFileExcel, FaFileCsv } from 'react-icons/fa';
import { getFileInfo } from 'utils/custom';
import * as Styled from './styles';

const ICON_SIZE = 70;

const FILE_ICONS = {
  pdf: <FaFilePdf size={ICON_SIZE} color="#D32F2F" aria-label="PDF file" role="img" />,
  txt: <FaFileAlt size={ICON_SIZE} color="#9BABB8" aria-label="Text file" role="img" />,
  doc: <FaFileWord size={ICON_SIZE} color="#2B579A" aria-label="Word document" role="img" />,
  docx: <FaFileWord size={ICON_SIZE} color="#2B579A" aria-label="Word document" role="img" />,
  ppt: <FaFilePowerpoint size={ICON_SIZE} color="#D24726" aria-label="PowerPoint presentation" role="img" />,
  pptx: <FaFilePowerpoint size={ICON_SIZE} color="#D24726" aria-label="PowerPoint presentation" role="img" />,
  xls: <FaFileExcel size={ICON_SIZE} color="#217346" aria-label="Excel spreadsheet" role="img" />,
  xlsx: <FaFileExcel size={ICON_SIZE} color="#217346" aria-label="Excel spreadsheet" role="img" />,
  csv: <FaFileCsv size={ICON_SIZE} color="#217346" aria-label="CSV file" role="img" />,
};

const FileIconLink = ({ value }) => {
  const { name, path, disabled } = getFileInfo(value);

  if (!name || !path) return null;

  const handleClick = (e, url) => {
    e.preventDefault();
    if (disabled) return;
    window.open(url, '_blank');
  };

  const handleKeyPress = ({ key }) => {
    if (disabled) return;
    if (key === 'Enter') {
      window.open(path, '_blank');
    }
  };

  return (
    <div>
      <Styled.Link
        href={path}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => handleClick(e, path)}
        onKeyDown={handleKeyPress}
        disabled={disabled}
        tabIndex="0"
        alt={`${name} link`}
      >
        {FILE_ICONS[name.split('.').pop()]}
      </Styled.Link>
      <p>{name}</p>
    </div>
  );
};

FileIconLink.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

FileIconLink.defaultProps = {
  value: [],
};

export default FileIconLink;
